<template>
  <div id='footer'>
    <footer class="page-footer blue accent-1">
      <div class="container">
        <div class="row">
          <div class="col l6 s12">
            <h5 class="white-text">Footer Content</h5>
            <p class="grey-text text-lighten-4">You can use rows and columns here to organize your footer content.</p>
          </div>
          <div class="col l4 offset-l2 s12">
            <h5 class="white-text">Links</h5>
            <ul>
              <li><a class="grey-text text-lighten-3" href="https://www.linkedin.com/in/hayatullah-ibrahimy-2a644473/" title="LinkedIn" target="_blank"><img style="width:40px;hight:40px;" src="../assets/Lin.png"/></a></li>
              <li><a class="grey-text text-lighten-3" href="https://www.facebook.com/Hayatullah.Ibrah" target="_blank" title="Facebook"><img style="width:40px;hight:40px;" src="../assets/faceb.png"/></a></li>
              <li><a class="grey-text text-lighten-3" href="https://twitter.com/H_Ibrahimy" target="_blank" title="Twitter"><img style="width:40px;hight:40px;" src="../assets/twit.png"/></a></li>
              
            </ul>
          </div>
        </div>
      </div>
      <div class="footer-copyright">
        <div class="container">
        Copyright © 2019 &reg; SEHI. All rights reserved SEHI &trade;
        <a class="grey-text text-lighten-4 right" href="#!"><i class="material-icons">check</i></a>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name:'myLovelyFooter'
}
</script>
<style scoped>

</style>
